import { initialState } from "../reducers/root.reducer";
import { IPaymentResponse } from "../../models/payment-response.interface";
import { PaymentAction } from "../actions/payment.actions";
import { PaymentActionTypes } from "../actions/types";

export const paymentReducer = (
  state: IPaymentResponse | null = null,
  action: PaymentAction
) : IPaymentResponse | null => {
  switch (action.type) {
    case PaymentActionTypes.INITIATE_PAYMENT:
      return state;
    case PaymentActionTypes.PAYMENT_PROCESS_STARTED:
     // console.log(action.payload);
      return action.payload;
    case PaymentActionTypes.PAYMENT_PROCESS_FAILED:
      return {url: null, token: null, failed: new Date() };
    case PaymentActionTypes.CLEAR_PAYMENT_RESPONSE:
      return initialState.paymentResponse;
    default:
      return state;
  }
};
